import ComingSoon from '@/pages/comming-soon';

/**
 * Search page component that displays a coming soon message for the search feature
 */
function SearchPage() {
  return (
    <ComingSoon
      title="Search Coming Soon"
      description="The 'Search' feature is currently under development. You'll be able to search across all your content soon."
    />
  );
}

export default SearchPage; 
